import { useEffect } from "react";

// Keeps a view fresh for collaborators: refetches when the tab/window regains focus
// and on a light interval while visible. No websockets needed.
export function useLiveRefresh(refresh, { interval = 25000 } = {}) {
  useEffect(() => {
    if (typeof refresh !== "function") return undefined;
    // Never refetch while the user is actively typing in a field — a background reload
    // can reset in-progress forms/modals. Resumes as soon as they blur.
    const isEditing = () => {
      const el = document.activeElement;
      if (!el) return false;
      const tag = el.tagName;
      return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable;
    };
    const run = () => { if (!isEditing()) refresh(); };
    const onFocus = () => run();
    const onVisible = () => {
      if (document.visibilityState === "visible") run();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") run();
    }, interval);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
      clearInterval(timer);
    };
  }, [refresh, interval]);
}
